import { useDetailApi } from "../../../swr/useApi";
import { categoriesService } from "../../api_client";
import type { CategoryDto } from "../../../api";

export function useCategory(id?: number | null) {
    return useDetailApi<CategoryDto>({
        key: `category-${id ?? "none"}`,
        serviceMethod: async () => await categoriesService.getCategoryById(id as number),
        options: {
            isPaused: () => !id,
        },
    });
}
